document.addEventListener('DOMContentLoaded', () => {
  // 1) DOM references
  const grid = document.querySelector('[data-blog-grid]');
  const btn  = document.querySelector('[data-blog-load-more]');
  const cardSelector = '.home_blog_card';

  if (!grid || !btn) return;

  // 2) UI state helpers
  const setLoading = (button, isLoading) => {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
  };

  // 3) Network: fetch and parse next page into a Document
  const fetchDocument = async (url) => {
    const res  = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
    const html = await res.text();
    return new DOMParser().parseFromString(html, 'text/html');
  };

  // 4) DOM updates: append new cards
  const appendCards = (srcDoc, destGrid) => {
    const nextGrid = srcDoc.querySelector('[data-blog-grid]');
    if (!nextGrid) return false;
    nextGrid.querySelectorAll(cardSelector).forEach(card => destGrid.appendChild(card));
    return true;
  };

  // 5) Pagination: sync next link or remove button if none
  const syncNextLink = (srcDoc, button) => {
    const nextBtn = srcDoc.querySelector('[data-blog-load-more]');
    if (nextBtn && nextBtn.dataset.nextUrl) {
      button.dataset.nextUrl = nextBtn.dataset.nextUrl;   // update to next page
      button.href = nextBtn.getAttribute('href');
      setLoading(button, false);
      return true;
    } else {
      button.remove(); // no more pages
      return false;
    }
  };

  // 6) Controller: click handler orchestrates the flow
  const onClickLoadMore = async (e) => {
    e.preventDefault();
    const url = btn.dataset.nextUrl;
    if (!url) return;

    setLoading(btn, true);

    try {
      const doc = await fetchDocument(url);
      appendCards(doc, grid);
      syncNextLink(doc, btn);
    } catch (err) {
      console.error(err);
      setLoading(btn, false);
    }
  };

  // 7) Init: wire events
  btn.addEventListener('click', onClickLoadMore);
});